<a
  class="brand-link h1 text-center"
  [routerLink]="['home']"
>
  <img
    src="../../../../../assets/img/logo-bussola.png"
    alt="Logo"
    class="logo"
    style="margin-right: 10px; margin-top: 20px; margin-bottom: 20px"
  />
</a>
